export const LAYOUT_CUSTOMER_DASHBOARD = 'layout-customer-dashboard';
export const LAYOUT_BUSINESS_DASHBOARD = 'layout-business-dashboard';
export const LAYOUT_LOGIN = 'layout-login';
export const LAYOUT_LOADING = 'layout-loading';
export const LAYOUT_PAYMENT_REQUEST = 'layout-payment-request';
export const LAYOUT_REGISTRATION = 'layout-registration';
export const LAYOUT_SIMPLE = 'layout-simple';
